const o="0x0000000000000000000000000000000000000000";export{o as ZeroAddress};
